import { render } from "./Packs.vue?vue&type=template&id=0db44907"
import script from "./Packs.vue?vue&type=script&lang=js"
export * from "./Packs.vue?vue&type=script&lang=js"
script.render = render

export default script